import { Film, Loader2 } from "lucide-react";
import { useState } from "react";
import { mediaUrl } from "lib/media";

const demoReelUrl = mediaUrl("website_files/videos/DemoReel2026.mp4");

export const FeaturedReel = () => {
  const [isReady, setIsReady] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className="relative aspect-[16/11] overflow-hidden border border-white/10 bg-black">
      {hasError ? (
        <div className="flex h-full flex-col items-center justify-center gap-5 px-8 text-center">
          <Film className="h-9 w-9 text-ember" />
          <p className="max-w-sm text-sm leading-7 text-white/60">
            The embedded reel could not be loaded in this browser.
          </p>
          <a
            href={demoReelUrl}
            className="button-secondary"
            target="_blank"
            rel="noreferrer"
          >
            Open demo reel
          </a>
        </div>
      ) : (
        <video
          className="h-full w-full object-contain"
          controls
          autoPlay
          muted
          playsInline
          preload="metadata"
          onCanPlay={() => setIsReady(true)}
          onError={() => setHasError(true)}
          aria-label="Gregory Kalamdaryan 2026 visual effects demo reel"
        >
          <source src={demoReelUrl} type="video/mp4" />
          Your browser does not support embedded video.
        </video>
      )}

      <div className="pointer-events-none absolute left-5 top-5 z-20 flex items-center gap-3 bg-black/45 px-3 py-2 text-[10px] font-bold uppercase tracking-[0.2em] text-white backdrop-blur-md sm:left-7 sm:top-7 sm:text-xs">
        <span className="h-2 w-2 rounded-full bg-ember shadow-[0_0_18px_rgba(255,92,54,0.9)]" />
        2026 Demo reel
      </div>

      {!isReady && !hasError && (
        <div className="pointer-events-none absolute inset-0 grid place-items-center bg-black/20">
          <span className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.18em] text-white/60">
            <Loader2 className="h-4 w-4 animate-spin text-ember" />
            Loading reel
          </span>
        </div>
      )}
    </div>
  );
};
